import { render, staticRenderFns } from "./RejectDialog.vue?vue&type=template&id=08407b80&scoped=true"
import script from "./RejectDialog.vue?vue&type=script&lang=js"
export * from "./RejectDialog.vue?vue&type=script&lang=js"
import style0 from "./RejectDialog.vue?vue&type=style&index=0&id=08407b80&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08407b80",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/CloseProject/RejectDialog.vue
// module id = 1990
// module chunks = 31